import LOCAL_EN from 'date-fns/locale/en-US';
import cloneDeep from 'lodash/cloneDeep';

type Width = 'narrow' | 'abbreviated' | 'wide';
type IMonthValues = {[key in Width]: string[]};

const ID_MONTH_VALUES: IMonthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Mei',
    'Jun',
    'Jul',
    'Agu',
    'Sep',
    'Okt',
    'Nov',
    'Des',
  ],
  wide: [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ],
};

const id = cloneDeep(LOCAL_EN);
// https://github.com/date-fns/date-fns/issues/1589
// date-fns에서 타입을 잘못 수정한 부분으로 Locale을 customize하지 않으면 모든 필드는 항상 존재한다.
id.localize!.month = (mon: number, {width}: {width: Width; context: string}) =>
  ID_MONTH_VALUES[width][mon];

export default id;
